import React from 'react';

// Composant EnvironmentFiche déplacé à l'extérieur pour éviter les re-renders
const EnvironmentFiche = React.memo(({ env, title, bgColor, data, updateFiche }) => (
  <div className={`border border-gray-200 rounded-lg p-6 ${bgColor}`}>
    <h3 className="text-lg font-semibold mb-4">{title}</h3>
    
    {/* Versions des composants */}
    <div className="mb-6">
      <h4 className="font-medium text-gray-700 mb-3">Versions des composants</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm text-gray-600 mb-1">Version Application</label>
          <input
            type="text"
            value={data[env]?.versions?.application || ''}
            onChange={(e) => updateFiche(env, 'versions', 'application', e.target.value)}
            placeholder="ex: 2.4.1"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Version Base de données</label>
          <input
            type="text"
            value={data[env]?.versions?.database || ''}
            onChange={(e) => updateFiche(env, 'versions', 'database', e.target.value)}
            placeholder="ex: PostgreSQL 13.4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Version API</label>
          <input
            type="text"
            value={data[env]?.versions?.api || ''}
            onChange={(e) => updateFiche(env, 'versions', 'api', e.target.value)}
            placeholder="ex: 1.8.0"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Version Frontend</label>
          <input
            type="text"
            value={data[env]?.versions?.frontend || ''}
            onChange={(e) => updateFiche(env, 'versions', 'frontend', e.target.value)}
            placeholder="ex: 3.2.0"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Version Serveur Web</label>
          <input
            type="text"
            value={data[env]?.versions?.webserver || ''}
            onChange={(e) => updateFiche(env, 'versions', 'webserver', e.target.value)}
            placeholder="ex: nginx 1.20.1"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Autres composants</label>
          <input
            type="text"
            value={data[env]?.versions?.autres || ''}
            onChange={(e) => updateFiche(env, 'versions', 'autres', e.target.value)}
            placeholder="Redis, RabbitMQ, etc."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>

    {/* Configuration */}
    <div className="mb-6">
      <h4 className="font-medium text-gray-700 mb-3">Configuration</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="md:col-span-2">
          <label className="block text-sm text-gray-600 mb-1">URLs d'accès</label>
          <textarea
            value={data[env]?.configuration?.urls || ''}
            onChange={(e) => updateFiche(env, 'configuration', 'urls', e.target.value)}
            rows="3"
            placeholder="URL portail patient: https://...&#10;URL portail soignant: https://...&#10;URL back-office: https://..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Port HTTPS</label>
          <input
            type="text"
            value={data[env]?.configuration?.portHttps || ''}
            onChange={(e) => updateFiche(env, 'configuration', 'portHttps', e.target.value)}
            placeholder="443"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Port Base de données</label>
          <input
            type="text"
            value={data[env]?.configuration?.portDb || ''}
            onChange={(e) => updateFiche(env, 'configuration', 'portDb', e.target.value)}
            placeholder="5432"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm text-gray-600 mb-1">Certificats SSL</label>
          <textarea
            value={data[env]?.configuration?.certificats || ''}
            onChange={(e) => updateFiche(env, 'configuration', 'certificats', e.target.value)}
            rows="2"
            placeholder="Information sur les certificats SSL (fournisseur, date d'expiration...)"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="md:col-span-2">
          <label className="block text-sm text-gray-600 mb-1">Paramètres spécifiques</label>
          <textarea
            value={data[env]?.configuration?.parametres || ''}
            onChange={(e) => updateFiche(env, 'configuration', 'parametres', e.target.value)}
            rows="3"
            placeholder="Paramètres de configuration spécifiques au client"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>

    {/* Notes d'installation */}
    <div>
      <h4 className="font-medium text-gray-700 mb-3">Notes d'installation</h4>
      <textarea
        value={data[env]?.notes || ''}
        onChange={(e) => updateFiche(env, 'notes', null, e.target.value)}
        rows="5"
        placeholder="Procédure d'installation, particularités, points d'attention..."
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  </div>
));

export const FicheInstallationTab = ({ data, setData }) => {
  const updateFiche = React.useCallback((env, section, field, value) => {
    setData(prev => ({
      ...prev,
      ficheInstallation: {
        ...prev.ficheInstallation,
        [env]: {
          ...prev.ficheInstallation?.[env],
          [section]: section === 'versions' || section === 'configuration' ? {
            ...prev.ficheInstallation?.[env]?.[section],
            [field]: value
          } : value
        }
      }
    }));
  }, [setData]);

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Fiches d'Installation</h2>
      
      {/* Production */}
      <EnvironmentFiche 
        env="production" 
        title="Fiche d'Installation PRODUCTION" 
        bgColor="bg-red-50"
        data={data}
        updateFiche={updateFiche}
      />

      {/* Qualification */}
      <EnvironmentFiche 
        env="qualification" 
        title="Fiche d'Installation QUALIFICATION" 
        bgColor="bg-blue-50"
        data={data}
        updateFiche={updateFiche}
      />

      {/* Informations importantes */}
      <div className="mt-8 bg-yellow-50 rounded-lg p-6 border border-yellow-200">
        <h4 className="font-semibold text-yellow-800 mb-3">Points importants à documenter :</h4>
        <ul className="list-disc list-inside space-y-1 text-sm text-yellow-700">
          <li>Les URLs doivent être documentées aussi dans l'onglet "Identité"</li>
          <li>Vérifier la cohérence des versions entre PROD et QUAL</li>
          <li>Noter toute configuration spécifique au client</li>
          <li>Documenter les dépendances et prérequis système</li>
          <li>Inclure les procédures de rollback si nécessaire</li>
        </ul>
      </div>
    </div>
  );
};